//Show loader on submit button
$('#accountLogin').on('submit', function (e) {
  $('.login-button').html('');
  jQuery('<i>', {
    class: 'fas fa-spinner fa-spin'
  }).appendTo('.login-button');
});
